__turbopack_context__.v({
  "container": "Project-module__7iGofq__container",
  "titleInput": "Project-module__7iGofq__titleInput",
  "titleText": "Project-module__7iGofq__titleText",
});
